
import React from 'react';
import { FiCheck, FiArrowRight } from 'react-icons/fi';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ICON_MAP } from '../../utils/constants';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Service feature highlight card component
 * Emphasizes the features list with a different visual style
 */
export const ServiceFeatureHighlightCard = ({ service, onDetailsClick }) => {
    const IconComponent = ICON_MAP[service.icon] || ICON_MAP.FiPackage;
    const { t } = useLanguage();

    return (
        <Card className="h-full border-none shadow-lg relative overflow-hidden group">
            {/* Background decoration */}
            <div className="absolute top-0 right-0 -mr-16 -mt-16 w-32 h-32 bg-primary/10 rounded-full group-hover:bg-primary/20 transition-colors duration-500 pointer-events-none" />

            <div className="relative z-10 p-6 flex flex-col h-full">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center text-primary mb-6 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent size={24} />
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {service.title}
                </h3>

                <div className="flex-grow">
                    <p className="text-gray-600 mb-6 text-sm">
                        {service.description}
                    </p>

                    <div className="bg-gray-50 rounded-lg p-4 mb-6">
                        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">
                            Features
                        </h4>
                        <ul className="space-y-2">
                            {service.features.map((feature, index) => (
                                <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                                    <FiCheck className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                                    <span>{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <Button
                    className="w-full"
                    onClick={() => onDetailsClick?.(service.id)}
                    aria-label={t('serviceCard.detailsAria', { 0: service.title })}
                >
                    {t('serviceCard.details')}
                    <FiArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
            </div>
        </Card>
    );
};
